import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GQ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GQ_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GQ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#GQ_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0z", fill: "#009D00" }), /* @__PURE__ */ e.createElement("path", { d: "M0 8v8h32V8H0z", fill: "#fff" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#F80000" })), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24l8-11.848L0 0z",
      fill: "#0075D5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GQ_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 8,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24l8-11.848L0 0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.57 8.882l-.014.003-.01-.009-.206-.19-.026.28v.013l-.012.006-.246.138.259.11.012.006.002.013.055.276.186-.212.009-.01.013.002.28.033-.145-.242-.007-.011.006-.012.118-.256-.275.062zM15.57 8.882l-.014.003-.01-.009-.206-.19-.026.28v.013l-.012.006-.246.138.259.11.012.006.002.013.055.276.186-.212.009-.01.013.002.28.033-.145-.242-.007-.011.006-.012.118-.256-.275.062zM16.57 8.882l-.014.003-.01-.009-.206-.19-.026.28v.013l-.012.006-.246.138.259.11.012.006.002.013.055.276.186-.212.009-.01.013.002.28.033-.145-.242-.006-.011.005-.012.118-.256-.275.062zM17.57 8.882l-.014.003-.01-.009-.206-.19-.026.28v.013l-.012.006-.246.138.259.11.012.006.002.013.055.276.186-.212.009-.01.013.002.28.033-.145-.242-.006-.011.005-.012.118-.256-.275.062zM18.57 8.882l-.014.003-.01-.009-.206-.19-.026.28v.013l-.012.006-.246.138.259.11.012.006.002.013.055.276.186-.212.009-.01.013.002.28.033-.145-.242-.006-.011.005-.012.118-.256-.275.062zM19.57 8.882l-.014.003-.01-.009-.206-.19-.026.28v.013l-.012.006-.246.138.259.11.012.006.002.013.055.276.186-.212.009-.01.013.002.28.033-.145-.242-.006-.011.005-.012.118-.256-.275.062z",
      fill: "#FFD500",
      stroke: "#000",
      strokeWidth: 0.05
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.05 10.05h3.9V13a1.95 1.95 0 11-3.9 0v-2.95z",
      stroke: "#373737",
      strokeWidth: 0.1
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.727 11.96s-.202 2.365-.403 2.508c-.201.144.965.215 1.076.108.112-.108-.508-2.035-.295-2.616.213-.582.557-.629.557-.629s-.433-.091-.557.083c-.124.175-.493-.083-.493-.083l.115.629z",
      fill: "#6F3E1D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.682 11.826h-.155s-.105.41-.346.205-.581-.133-.581-.133.03-.246.4-.343c.37-.098.527-.891.527-.891s.523-.195.842.204c.318.4.767.23.767.23s.328.186.164.457c-.164.27-.444.47-.687.27-.244-.197-.931 0-.931 0z",
      fill: "#009D29"
    }
  ))
);
export {
  t as default
};
